import React, { useState } from "react";
import "./Css/Notification.css";

const initialNotifications = [
  {
    id: 1,
    title: "नवीन प्रश्न बँक उपलब्ध",
    description:
      "संपूर्ण ५ वयांच्या 'सूचना स्तरीय तंत्र विज्ञान' विषयासंबंधी नवीन प्रश्न बँक उपलब्ध आहे. कृपया तपासा आणि आवश्यक असल्यास प्रश्न मॅनेज करा.",
    date: "०१/११/२०२५",
    unread: true,
  },
  {
    id: 2,
    title: "शिक्षकांना नवीन परीक्षा तयार केली",
    description:
      "शिक्षक प्राधिकरण सॉफ्टवेअर मध्ये 'गणित - अध्याय ३ विज्ञान' ची नवीन परीक्षा तयार केली आहे. ती Admin Approval साठी प्रेषित आहे.",
    date: "०१/११/२०२५",
    unread: true,
  },
  {
    id: 3,
    title: "परीक्षे प्रक्रिया करताना तुटलेली",
    description: "काहीतरी माहिती तुटली आहे आणि परीक्षा प्रक्रिया पूर्ण करण्यात समस्या आली.",
    date: "०१/११/२०२५4",
    unread: true,
  },
  {
    id: 4,
    title: "विद्यार्थ्यांनी परीक्षा पूर्ण केली",
    description: "विद्यार्थ्यांनी परीक्षा पूर्ण केली आहे.",
    date: "०१/११/२०२५",
    unread: false,
  },
  {
    id: 5,
    title: "कुठे कितीही नोंद झाली",
    description: "सर्व नोंदी पूर्ण झाल्या आहेत.",
    date: "१८/१०/२०२५",
    unread: false,
  },
  {
    id: 6,
    title: "शिक्षकाचा पासवर्ड अद्ययावत झाला",
    description: "शिक्षकांचा पासवर्ड यशस्वीरित्या बदलला गेला आहे.",
    date: "१०/०९/२०२५",
    unread: false,
  },
];

const NotificationPanel = () => {
  const [notifications, setNotifications] = useState(initialNotifications);
  const [searchText, setSearchText] = useState("");

  const unreadCount = notifications.filter((n) => n.unread).length;
  


  const markAllRead = () => {
    setNotifications(
      notifications.map((n) => ({ ...n, unread: false }))
    );
  };

  const filteredNotifications = notifications.filter(
    (n) =>
      n.title.toLowerCase().includes(searchText.toLowerCase()) ||
      n.description.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="notification-container">
      <div className="notification-header">
        <h2>सूचना</h2>
      </div>

      <div className="search-wrapper">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className="search-icon"
  >
    <path
      d="M19.4853 20.154L13.2238 13.8925C12.7238 14.3182 12.1488 14.6477 11.4988 14.881C10.8488 15.1144 10.1957 15.231 9.53934 15.231C7.93768 15.231 6.58209 14.6766 5.47259 13.5678C4.36326 12.4589 3.80859 11.1042 3.80859 9.50353C3.80859 7.9027 4.36301 6.54678 5.47184 5.43578C6.58068 4.32495 7.93543 3.76953 9.53609 3.76953C11.1369 3.76953 12.4928 4.3242 13.6038 5.43353C14.7147 6.54303 15.2701 7.89861 15.2701 9.50028C15.2701 10.1951 15.147 10.8675 14.9008 11.5175C14.6547 12.1675 14.3316 12.7233 13.9316 13.1848L20.1931 19.4465L19.4853 20.154ZM9.53934 14.231C10.8662 14.231 11.9863 13.7743 12.8998 12.8608C13.8133 11.9474 14.2701 10.8273 14.2701 9.50028C14.2701 8.17328 13.8133 7.05311 12.8998 6.13978C11.9863 5.22628 10.8662 4.76953 9.53934 4.76953C8.21234 4.76953 7.09218 5.22628 6.17884 6.13978C5.26534 7.05311 4.80859 8.17328 4.80859 9.50028C4.80859 10.8273 5.26534 11.9474 6.17884 12.8608C7.09218 13.7743 8.21234 14.231 9.53934 14.231Z"
      fill="#1F1F1F"
    />
  </svg>
  <input
    type="text"
    placeholder="Search"
    className="notification-search"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
  />
</div>

      <div className="sec-head">
        <div>
         <h2> सूचना</h2>
        <p>
  {unreadCount > 0
    ? `तुमच्याकडे ${unreadCount} न वाचलेल्या सूचना आहेत.`
    : "सर्व सूचना वाचलेल्या आहेत."}
</p>

         </div>
         <div>
        <button onClick={markAllRead} className="mark-read-btn">
          Mark as all read
        </button></div></div>

      <div className="notification-list">
        {filteredNotifications.map((n) => (
          <div
            key={n.id}
            className={`notification-item ${n.unread ? "unread" : ""}`}
          >
            <div className="notification-left">
              <div className={`icon ${n.unread ? "active" : ""}`}><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="currentColor">
  <g clip-path="url(#clip0_654_11681)">
    <path d="M12.8876 18.6354C12.8238 18.9669 12.7119 19.2711 12.5499 19.5497C12.3829 19.8351 12.1641 20.0932 11.8954 20.3187C11.625 20.5443 11.3321 20.7152 11.0135 20.8297C10.6948 20.9442 10.3572 21.0006 10.0006 21.0006C9.64236 21.0006 9.30475 20.9425 8.98781 20.8297C8.67087 20.7152 8.37632 20.546 8.10761 20.3187C7.83717 20.0915 7.62014 19.8351 7.45305 19.5497C7.28597 19.2643 7.17229 18.9499 7.11028 18.6046C7.07927 18.4372 7.19296 18.2765 7.36176 18.2457C7.36693 18.2457 7.41688 18.2406 7.41688 18.2406H12.5878C12.7601 18.2406 12.9013 18.379 12.9013 18.5517C12.8996 18.5807 12.8944 18.6081 12.8876 18.6354ZM3.48096 0.0433548C3.79618 -0.0814011 4.15274 0.0724076 4.27848 0.385152C4.40422 0.697896 4.2492 1.05166 3.93398 1.17641C3.25187 1.44643 2.67999 1.8207 2.22353 2.30605C1.76879 2.7914 1.42601 3.39296 1.20209 4.11586C1.10218 4.43715 0.757679 4.61831 0.433848 4.51919C0.110017 4.42006 -0.0725681 4.07827 0.0273371 3.75698C0.308105 2.85122 0.742177 2.09243 1.32266 1.47377C1.90314 0.856831 2.62487 0.381734 3.48096 0.0433548ZM16.0656 1.17641C15.7504 1.05166 15.5953 0.697896 15.7211 0.385152C15.8468 0.0724076 16.2034 -0.0814011 16.5186 0.0433548C17.3747 0.381734 18.0964 0.856832 18.6769 1.47548C19.2574 2.09585 19.6932 2.85463 19.9722 3.75869C20.0721 4.07998 19.8895 4.42177 19.5657 4.52089C19.2419 4.62002 18.8974 4.43886 18.7975 4.11757C18.5735 3.39296 18.2308 2.7914 17.776 2.30776C17.3196 1.8207 16.7477 1.44643 16.0656 1.17641ZM12.3863 2.04116C12.7377 2.17959 13.0753 2.34536 13.3991 2.53847C13.4112 2.54702 13.425 2.55385 13.437 2.5624C13.7471 2.7521 14.0365 2.96059 14.3017 3.18618C14.8684 3.66982 15.3404 4.2372 15.7142 4.87978C15.9002 5.20107 16.0604 5.53603 16.193 5.88125C16.3291 6.23842 16.4307 6.60244 16.4996 6.97671C16.5668 7.35268 16.6013 7.7372 16.6013 8.13198C16.6013 8.91128 16.6013 9.3334 16.6013 9.38466C16.603 9.78457 16.6047 10.1759 16.6082 10.557V10.5604C16.6099 10.9057 16.6323 11.2526 16.6753 11.5995C16.7184 11.943 16.7804 12.2746 16.8614 12.5941C16.9423 12.9086 17.0526 13.2128 17.1886 13.5033C17.3299 13.8024 17.5021 14.0963 17.7037 14.3817H17.7054C17.9052 14.662 18.155 14.9406 18.4547 15.214C18.7647 15.496 19.123 15.7746 19.533 16.0446C19.7672 16.2001 19.831 16.5163 19.6725 16.7487C19.5743 16.8939 19.4124 16.9743 19.247 16.9743V16.976H14.6221H10.0006H5.37571H0.752512C0.468298 16.976 0.239205 16.7487 0.239205 16.4667C0.239205 16.2821 0.33911 16.1198 0.487246 16.0309C0.902369 15.7523 1.25893 15.4755 1.55692
     15.202C1.85319 14.9303 2.10123 14.6518 2.30104 14.3646C2.30621 14.3561 2.3131 14.3476 2.31999 14.3407C2.51291 14.0604 2.67827 13.775 2.81435 13.4845C2.95387 13.1889 3.06583 12.8847 3.14852 12.5719C3.15024 12.5651 3.15196 12.5582 3.15368 12.5531C3.23292 12.2489 3.29321 11.9276 3.33455 11.591C3.37589 11.2526 3.39828 10.9022 3.39828 10.5416V8.13198C3.39828 7.74404 3.43273 7.35952 3.50335 6.975C3.57397 6.59218 3.6756 6.22475 3.81168 5.87441C3.94603 5.52407 4.10795 5.1874 4.2957 4.86611C4.67465 4.21669 5.1449 3.65444 5.72021 3.16738C6.00098 2.92983 6.30414 2.71279 6.6297 2.51967C6.9587 2.32485 7.29975 2.16079 7.65114 2.02749C7.89574 1.9352 8.14895 1.8583 8.40732 1.79506C8.49517 1.48916 8.64675 1.24135 8.86206 1.05166C9.15833 0.790181 9.54762 0.660298 10.0316 0.665425C10.5105 0.668843 10.8981 0.800435 11.1909 1.06191C12.2261 1.97622 10.9377 1.47377 12.3863 2.04116Z" fill="currentColor"/>
  </g>
  <defs>
    <clipPath id="clip0_654_11681">
      <rect width="20" height="21" fill="currentColor"/>
    </clipPath>
  </defs>
</svg></div>
            </div>
            <div className="notification-content">
              <h3>{n.title}</h3>
              <p>{n.description}</p>
            </div>
            <div className="notification-right">
              <span className="status">{n.unread ? "Unread" : ""}</span>
              <span>{n.date}</span>
              <button className="delete-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M7.6155 19.9997C7.15517 19.9997 6.77083 19.8456 6.4625 19.5372C6.15417 19.2289 6 18.8446 6 18.3842V5.99972H5V4.99972H9V4.23047H15V4.99972H19V5.99972H18V18.3842C18 18.8446 17.8458 19.2289 17.5375 19.5372C17.2292 19.8456 16.8448 19.9997 16.3845 19.9997H7.6155ZM9.80775 16.9997H10.8078V7.99972H9.80775V16.9997ZM13.1923 16.9997H14.1923V7.99972H13.1923V16.9997Z" fill="#FF1501"/>
</svg></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NotificationPanel;
